import axios from "axios";

export const AXIOS = axios.create({ withCredentials: true });

let IS_REDIRECTING = false;
const NO_AUTH_URLS = [
  "/auth/signin",
  "/auth/session",
  "/auth/local/signin",
  "/auth/local/signup",
];

// add cookie request interceptor; ensures queries don't fire without a secure cookie
AXIOS.interceptors.request.use(
  (config) => {
    const auth = localStorage.getItem("GRACE_AUTHENTICATED");
    const noAuthURL = NO_AUTH_URLS.some((url) => config.url?.includes(url));

    // check authentication + url
    const cancel = !auth && !noAuthURL;

    if (cancel) throw new Error("No authentication found.");

    return config;
  },
  (error) => Promise.reject(error)
);

// set up Axios interceptor to handle 401 errors
AXIOS.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      console.log("401: user unauthorized or token expired");

      const pathname = window.location.pathname;

      const currentPath = pathname + window.location.search;
      localStorage.setItem("GRACE_REDIRECT_URL", currentPath); // store current (redirect) page

      // remove auth flag
      localStorage.removeItem("GRACE_AUTHENTICATED");

      if (
        !IS_REDIRECTING &&
        pathname !== "/signin" &&
        pathname !== "/status" &&
        pathname !== "/local/signin" &&
        pathname !== "/local/signup"
      ) {
        IS_REDIRECTING = true;
        window.location.href = "/signin"; // redirect to signin screen
      }
    }
    return Promise.reject(error);
  }
);
